import React, { Component } from 'react';

import './style.sass';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

class Problem extends Component {
    render() {
        return (
            <ScrollAnimation animateIn="fadeInUp" offset={100} animateOnce={true} duration={1}>
                <div className="fondrt-problem">
                    <div className="fondrt-problem__title">Задачи</div>
                    <div className="fondrt-problem__list">
                        <div className="fondrt-problem__col1">
                            <div className="fondrt-problem__item">
                                <img
                                    className="fondrt-problem__image"
                                    src="/images/pic/fondrt/arrow.png"
                                    alt=""
                                    loading="lazy"
                                />
                                <div className="fondrt-problem__text">
                                    аудит и тестирование функционала сайта;
                                </div>
                            </div>
                            <div className="fondrt-problem__item">
                                <img
                                    className="fondrt-problem__image"
                                    src="/images/pic/fondrt/arrow.png"
                                    alt=""
                                    loading="lazy"
                                />
                                <div className="fondrt-problem__text">
                                    доработка сервисных страниц личного кабинета;
                                </div>
                            </div>
                            <div className="fondrt-problem__item">
                                <img
                                    className="fondrt-problem__image"
                                    src="/images/pic/fondrt/arrow.png"
                                    alt=""
                                    loading="lazy"
                                />
                                <div className="fondrt-problem__text">
                                    интеграция государственных информационных систем и баз данных;
                                </div>
                            </div>
                        </div>

                        <div className="fondrt-problem__col2">
                            <div className="fondrt-problem__item">
                                <img
                                    className="fondrt-problem__image"
                                    src="/images/pic/fondrt/arrow.png"
                                    alt=""
                                    loading="lazy"
                                />
                                <div className="fondrt-problem__text">
                                    поддержание работоспособности действующих сервисов;
                                </div>
                            </div>
                            <div className="fondrt-problem__item">
                                <img
                                    className="fondrt-problem__image"
                                    src="/images/pic/fondrt/arrow.png"
                                    alt=""
                                    loading="lazy"
                                />
                                <div className="fondrt-problem__text">
                                    повышение уровня информационной безопасности сервиса;
                                </div>
                            </div>
                            <div className="fondrt-problem__item">
                                <img
                                    className="fondrt-problem__image"
                                    src="/images/pic/fondrt/arrow.png"
                                    alt=""
                                    loading="lazy"
                                />
                                <div className="fondrt-problem__text">
                                    развитие и техническая поддержка проекта.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ScrollAnimation>
        );
    }
}

export default Problem;
